import React, { useState, useEffect } from "react";
import { Card, PageHeader, Table, Spinner, ErrBox, Input, Select, Btn } from "../components/UI";
import Badge from "../components/Badge";
import { fmtDate } from "../utils/format";
import { dashboardAPI } from "../utils/api";

const AuditTrailPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [filters, setFilters] = useState({ action: "", resource: "", dari: "", sampai: "" });
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 30;

  const load = async () => {
    setLoading(true); setErr("");
    try {
      const params = new URLSearchParams({ page, limit });
      if (filters.action)   params.set("action", filters.action);
      if (filters.resource)  params.set("resource", filters.resource);
      if (filters.dari)      params.set("dari", filters.dari);
      if (filters.sampai)    params.set("sampai", filters.sampai);
      const r = await dashboardAPI.auditTrail(`?${params.toString()}`);
      setData(r.data || []);
      setTotal(r.total || 0);
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [page]);

  const resourceOpts = [
    { value: "", label: "Semua Modul" },
    { value: "anggaran", label: "RENDAL (Anggaran)" },
    { value: "revisi_anggaran", label: "Revisi Anggaran" },
    { value: "procurement_request", label: "BALAKADA (Pengadaan)" },
    { value: "vendor_contract", label: "PPK (Kontrak)" },
    { value: "payment_request", label: "FINANCE (Pembayaran)" },
    { value: "document_workflow", label: "Workflow" },
  ];

  return (
    <div>
      <PageHeader title="Audit Trail" subtitle="Log aktivitas sistem — semua perubahan data tercatat" />
      <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
        <div style={{ minWidth: 160 }}>
          <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6B7280", marginBottom: 4 }}>Aksi</label>
          <Input value={filters.action} onChange={e => setFilters({ ...filters, action: e.target.value })} placeholder="Cari aksi..." />
        </div>
        <div style={{ minWidth: 180 }}>
          <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6B7280", marginBottom: 4 }}>Modul</label>
          <Select value={filters.resource} onChange={e => setFilters({ ...filters, resource: e.target.value })} options={resourceOpts} />
        </div>
        <div>
          <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6B7280", marginBottom: 4 }}>Dari</label>
          <input type="date" value={filters.dari} onChange={e => setFilters({ ...filters, dari: e.target.value })}
            style={{ padding: "8px 12px", border: "1px solid #D1D5DB", borderRadius: 8, fontSize: 13 }} />
        </div>
        <div>
          <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6B7280", marginBottom: 4 }}>Sampai</label>
          <input type="date" value={filters.sampai} onChange={e => setFilters({ ...filters, sampai: e.target.value })}
            style={{ padding: "8px 12px", border: "1px solid #D1D5DB", borderRadius: 8, fontSize: 13 }} />
        </div>
        <Btn onClick={() => { setPage(1); load(); }}>Cari</Btn>
        <Btn variant="ghost" onClick={() => { setFilters({ action: "", resource: "", dari: "", sampai: "" }); setPage(1); }}>Reset</Btn>
      </div>
      <Card>
        {err && <div style={{ marginBottom: 12 }}><ErrBox msg={err} onRetry={load} /></div>}
        {loading ? <Spinner /> : (
          <>
            <Table pageSize={limit} cols={[
              { key: "created_at", label: "Waktu", nowrap: true, render: v => (
                <span style={{ fontSize: 12, fontFamily: "monospace", color: "#374151" }}>{v ? new Date(v).toLocaleString("id-ID") : "-"}</span>
              )},
              { key: "user_name", label: "User", render: (v, r) => (
                <div>
                  <span style={{ fontWeight: 600, fontSize: 12 }}>{v || r.username}</span>
                  <br /><span style={{ fontSize: 10, color: "#6B7280" }}>{r.role}</span>
                </div>
              )},
              { key: "action", label: "Aksi", render: v => <Badge status={v} /> },
              { key: "resource", label: "Modul", render: v => (
                <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 6px", borderRadius: 6, background: "#F3F4F6", color: "#374151" }}>{v || "-"}</span>
              )},
              { key: "resource_id", label: "ID", render: v => v ? <span style={{ fontSize: 11, fontFamily: "monospace", color: "#6B7280" }}>{String(v).slice(0, 8)}...</span> : "-" },
              { key: "detail", label: "Detail", render: v => v ? <span style={{ fontSize: 11, color: "#6B7280", maxWidth: 200, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{JSON.stringify(v)}</span> : "-" },
              { key: "ip_address", label: "IP", render: v => <span style={{ fontSize: 11, fontFamily: "monospace" }}>{v || "-"}</span> },
            ]} data={data} />
            {total > limit && (
              <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 16 }}>
                <Btn size="sm" variant="ghost" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</Btn>
                <span style={{ padding: "6px 12px", fontSize: 13 }}>Halaman {page} dari {Math.ceil(total / limit)}</span>
                <Btn size="sm" variant="ghost" disabled={page * limit >= total} onClick={() => setPage(p => p + 1)}>Next</Btn>
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
};

export default AuditTrailPage;
